import { useOfflineFirstQuery } from '../../../hooks/useOfflineFirstQuery'
import { apiClient } from '../../../api/client'

type Denial = {
  id: string
  denial_reason: string
  status: string
  denial_date: string
  claim_id: string
  carc_code?: string
  rarc_code?: string
}

export default function DenialsListPage() {
  const { data, isFetching, error, refetch } = useOfflineFirstQuery<Denial[]>({
    queryKey: ['denials'],
    cacheKey: 'denials:list',
    staleTime: 1000 * 60,
    queryFn: async () => {
      const res = await apiClient.get('/api/v1/billing/denials/')
      return res.data as Denial[]
    },
  })

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="text-xl font-semibold text-gray-900">Denials Work Queue</h1>
        <button
          onClick={() => refetch()}
          className="rounded-md border border-gray-200 px-3 py-2 text-sm text-gray-700 hover:bg-gray-50"
        >
          Refresh
        </button>
      </div>

      {error && (
        <div className="rounded-md border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-800">
          {(error as Error).message}
        </div>
      )}

      <div className="overflow-hidden rounded-lg border border-gray-200 bg-white">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Date</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Code</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Reason</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Status</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Claim</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 bg-white">
            {isFetching && (
              <tr>
                <td colSpan={5} className="px-4 py-4 text-center text-sm text-gray-500">
                  Loading…
                </td>
              </tr>
            )}
            {data?.map((d) => (
              <tr key={d.id}>
                <td className="px-4 py-3 text-sm text-gray-700">{d.denial_date}</td>
                <td className="px-4 py-3 text-sm text-gray-700">{d.carc_code ?? d.rarc_code ?? '—'}</td>
                <td className="px-4 py-3 text-sm text-gray-700">{d.denial_reason}</td>
                <td className="px-4 py-3 text-sm text-gray-700">{d.status}</td>
                <td className="px-4 py-3 text-sm text-gray-700">{d.claim_id}</td>
              </tr>
            ))}
            {!isFetching && (!data || data.length === 0) && (
              <tr>
                <td colSpan={5} className="px-4 py-4 text-center text-sm text-gray-500">
                  No denials in queue.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}
